export default {"src":"/_next/static/media/begin.b331ab2e.svg","height":329,"width":403,"blurWidth":0,"blurHeight":0};